import { render, staticRenderFns } from "./QuestionnaireVariantForm.vue?vue&type=template&id=34acfc9e&scoped=true"
import script from "./QuestionnaireVariantForm.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireVariantForm.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireVariantForm.vue?vue&type=style&index=0&id=34acfc9e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34acfc9e",
  null
  
)

export default component.exports